export default "__VITE_ASSET__B5xcX3FE__"